import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { GitaDataProvider } from './context/GitaDataContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <GitaDataProvider>
        <App />
      </GitaDataProvider>
    </BrowserRouter>
  </React.StrictMode>
);
